import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const {
    login,
    isLoading
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Default to Admin role for all users since role selection is removed
    login(email, 'Admin');
    navigate('/');
  };
  return <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4" data-id="element-186">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-187">
        {/* Header */}
        <div className="bg-emerald-700 p-8 text-center" data-id="element-188">
          <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4 backdrop-blur-sm" data-id="element-189">
            <span className="text-3xl font-bold text-white" data-id="element-190">L</span>
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-191">LISF Portal</h1>
          <p className="text-emerald-100 mt-2" data-id="element-192">
            Land Information and Service Framework
          </p>
        </div>

        {/* Form */}
        <div className="p-8" data-id="element-193">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-194">
            <Input label="Email Address" type="email" placeholder="admin@land.gov.bd" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-195" />

            <Input label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-196" />

            <div className="flex items-center justify-between text-sm" data-id="element-197">
              <label className="flex items-center text-slate-600" data-id="element-198">
                <input type="checkbox" className="mr-2 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500" data-id="element-199" />
                Remember me
              </label>
              <a href="#" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-200">
                Forgot password?
              </a>
            </div>

            <Button type="submit" className="w-full bg-emerald-700 hover:bg-emerald-800" size="lg" isLoading={isLoading} data-id="element-201">
              Sign In to Dashboard
            </Button>
          </form>

          <div className="mt-6 text-center text-xs text-slate-400" data-id="element-202">
            &copy; 2024 Ministry of Land, Bangladesh. All rights reserved.
          </div>
        </div>
      </div>
    </div>;
}